import TableSkeleton from "@components/shared/loading/TableSkeleton";
import { Box, Typography, styled, Link } from "@mui/material";

const RecruiterPhoto = styled(Box)(({ theme }) => ({
  width: "140px",
  height: "140px",
  borderRadius: "75px",
  overflow: "hidden",

  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
}));

export default function EmailFooter({ recruiter, showProfileImage = true }) {
  if (!recruiter) {
    return <TableSkeleton />;
  }

  return (
    <div>
      <hr width="100%" />
      <table width="800px" cellPadding="6px" border="0">
        <tbody>
          <tr>
            {showProfileImage && (
              <td
                align="left"
                valign="top"
                style={{
                  width: "140px",
                  paddingRight: "20px",
                  verticalAlign: "top",
                }}
              >
                {recruiter.photo_url && (
                  <RecruiterPhoto>
                    <img src={recruiter.photo_url} alt={recruiter.name} />
                  </RecruiterPhoto>
                )}
              </td>
            )}
            <td valign="top" style={{ verticalAlign: "top" }}>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <Typography
                        variant="h3"
                        component="h3"
                        sx={{ mb: "6px" }}
                      >
                        {recruiter?.user.name}
                      </Typography>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Typography variant="h4" component="h4">
                        {recruiter.company}
                      </Typography>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Typography
                        variant="h4"
                        component="h4"
                        sx={{ mb: "4px", color: "#454545" }}
                      >
                        {recruiter.job_title}
                      </Typography>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {recruiter.linkedin_url && (
                        <Link href={recruiter.linkedin_url} target="_blank">
                          Connect on LinkedIn
                        </Link>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {recruiter.mobile_phone && (
                        <Typography variant="body1">
                          Call {recruiter.mobile_phone}
                        </Typography>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
